<div class="user-cta-wrapper d-flex flex-column w-100">
    <div class="cta-pill rounded-pill justify-content-between align-items-center row w-100">
        <span class="primary-text col-6 flex-grow-1">Try Qeleo for free.</span>
        <a href="https://qeleo.ai/" target="_blank" class="cta-btn col-6 invert-text btn rounded-pill d-flex justify-content-center align-items-center btn-sm">
            Let’s go
            <app-qeleo-icon iconName="arrow-right-o" size="sm"></app-qeleo-icon>
        </a>
    </div>
    <div class="cta-pill rounded-pill justify-content-between align-items-center row w-100">
        <span class="col-6 primary-text flex-grow-1">Get help with a solution.</span>
        <button (click)="openContactModal()" class="cta-btn col-6 talk-btn invert-text btn rounded-pill d-flex justify-content-center align-items-center btn-sm">
            Let’s talk
            <app-qeleo-icon iconName="arrow-right-o" size="sm"></app-qeleo-icon>
        </button>
    </div>
</div>
